import { api } from './client'

export type MemberRole = 'owner' | 'admin' | 'member' | 'viewer'

export const MEMBER_ROLES: MemberRole[] = ['owner', 'admin', 'member', 'viewer']

/** Minimum initial password length — mirrors MembersController::MIN_PASSWORD_LENGTH. */
export const MIN_PASSWORD_LENGTH = 12

export type Member = {
  id: number
  name: string
  email: string
  role: MemberRole
  avatar_color: string | null
  timezone: string
  is_active: boolean
  last_login_at: string | null
  created_at: string
}

export async function listMembers(): Promise<Member[]> {
  return api<Member[]>('/members')
}

export type MemberCreate = {
  name: string
  email: string
  password: string
  role?: MemberRole
  avatar_color?: string
  timezone?: string
}

export async function createMember(data: MemberCreate): Promise<Member> {
  return api<Member>('/members', { method: 'POST', body: data })
}

export type MemberUpdate = {
  name?: string
  role?: MemberRole
  avatar_color?: string
  timezone?: string
  is_active?: number
}

export async function updateMember(id: number, patch: MemberUpdate): Promise<Member> {
  return api<Member>(`/members/${id}`, { method: 'PATCH', body: patch })
}

/** Deactivates (is_active = 0) and revokes tokens — never a hard delete. */
export async function deactivateMember(id: number): Promise<Member> {
  return api<Member>(`/members/${id}`, { method: 'DELETE' })
}
